import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { SavedTechChartService } from 'NewAngular/features/components/saved-items/services/saved-tech-chart.service';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/features/components/saved-items/services/saved-tech-chart.service";
export class TechChartFolderableCollectionService extends FolderableCollectionLoadOnScrollServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        const dataParams = formFlattenedObject(this.dataParams, Object.keys(this.dataParams));
        return this.savedTechChartService.getFolderableItems(dataParams);
    }
    constructor(savedTechChartService) {
        super();
        this.savedTechChartService = savedTechChartService;
        this.scrollableBodyId = 'techChartsTable';
    }
}
TechChartFolderableCollectionService.ɵfac = function TechChartFolderableCollectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TechChartFolderableCollectionService)(i0.ɵɵinject(i1.SavedTechChartService)); };
TechChartFolderableCollectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TechChartFolderableCollectionService, factory: TechChartFolderableCollectionService.ɵfac });
